// Deterministic PRNG. The demo has no backend, so every "server" value
// (pre-sold inventory, draw results, past history) is derived from a seed
// instead of stored: a reload rebuilds the exact same session from the
// same seed, and past draws stay stable without persisting them.

// mulberry32 — 32-bit state, uniform enough for a UI simulation and short
// enough to read. Not for anything security-related.
export function createRandom(seed) {
    let state = seed >>> 0;
    return function next() {
        state = (state + 0x6d2b79f5) >>> 0;
        let value = state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296;
    };
}

export function randomInt(random, maxExclusive) {
    return Math.floor(random() * maxExclusive);
}

// Mixes two integers into one seed so callers can derive independent
// streams from the same session seed (inventory vs. draw results).
export function mixSeed(seed, salt) {
    return (Math.imul(seed ^ salt, 0x27d4eb2d) ^ (seed >>> 3)) >>> 0;
}

export function pickOne(random, items) {
    if (!items.length) return null;
    return items[randomInt(random, items.length)];
}
